import { Link } from 'react-router-dom';
import { data as sidebarData } from '../../data/data';
import './Sidebar.scss';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const data = sidebarData;

const SidebarComponent = ({ onItemClickHandler, onSidebarVisibliity }) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const clickHandler = (param) => {
    navigate(`${param}`);
    onItemClickHandler(param);
    closeSidebar();
  };

  const closeSidebar = () => {
    setVisible(false);
    setTimeout(() => {
      onSidebarVisibliity();
    }, 500);
  };
  const showSidebar = () => {
    setVisible(true);
    onSidebarVisibliity();
  };
  return (
    <div className='Sidebar'>
      <button type='button' className='open' data-dismiss='modal' aria-label='Close' onClick={showSidebar}>
        <span aria-hidden='true'>&#x2630;</span>
      </button>
      <div className={`content ${visible ? 'visible' : ''}`}>
        <button type='button' className='close' data-dismiss='modal' aria-label='Close' onClick={closeSidebar}>
          <span aria-hidden='true'>&times;</span>
        </button>
        <h2>Inhalt</h2>
        <ul>
          {data.map((item) => (
            <li key={item.elementId}>
              <p onClick={() => clickHandler(item.elementId)}>{item.title}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SidebarComponent;
